import { useDesigns } from '@customink/project-service-react-components';

export const useHasPersonalization = () => {
  const designsById = useDesigns();
  const designs = Object.values(designsById);
  return designs.some((design) => design?.personalization?.length > 0);
};
